"use client";

import React, { useState } from "react";
import { Check } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const plans = [{
  name: "Post & Paket",
  description: "Ihre Geschäftsadresse in professionellen Händen.",
  priceMonthly: "19",
  priceYearly: "€20",
  features: ["Briefkasten", "E-Mail Benachrichtigung", "Wöchentlicher Versand", "Post-Scan-Option"],
  isPopular: false,
  buttonText: "Service buchen",
  buttonVariant: "outline" as const
}, {
  name: "Mobilität",
  description: "Immer geladen und entspannt ankommen.",
  priceMonthly: "45",
  priceYearly: "\n",
  features: ["E-Auto Ladestation", "Post Einlagerung", "Fahrrad-Stellplatz", "E-Scooter Station", "24/7 Zugang zum Deck"],
  isPopular: true,
  buttonText: "Jetzt sichern",
  buttonVariant: "default" as const
}];
export default function Preisgestaltung() {
  const [isYearly, setIsYearly] = useState(false);
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}